<template>
  <div
    class="modal fade"
    v-show="regModal"
    id="regModal"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <button
          type="button"
          class="close-model-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>

        <div class="content-model-me">
          <div class="modal-header">
            <h2 class="section-title">إنشاء حساب</h2>
          </div>

          <form @submit.prevent="signup()" class="modal-form" ref="signUpForm">
            <div class="modal-body">
              <div class="inputs-container">
                <div class="input-g" :class="{ error: v$.name.$error }">
                  <label :for="registerIds.name" class="main-label"> اسم المستخدم <span style="font-size: 11px; color: #888;">(يرجي الكتابه باللغه الانجليزية)</span> </label>
                  <div class="main-input">
                    <input
                      name="name"
                      type="text"
                      class="input-me"
                      :class="{ error: v$.name.$error }"
                      placeholder="أدخل اسم المستخدم"
                      :id="registerIds.name"
                      autocomplete="name"
                      v-model="name"
                    />
                  </div>

                  <span class="error" v-if="v$.name.$error">
                    {{ $t("validation.required") }}
                  </span>
                </div>

                <div class="input-g" :class="{ error: v$.phone.$error }">
                  <label :for="registerIds.phone" class="main-label"> رقم الجوال <span style="font-size: 11px; color: #888;">(يرجي الكتابه باللغه الانجليزية)</span> </label>
                  <div class="main-input phone-input-group">
                    <select class="country-code-select" v-model="phoneCountryCode" aria-label="كود الدولة">
                      <option v-for="c in countryCodes" :key="c.code" :value="c.code">{{ formatCodeLabel(c) }}</option>
                    </select>
                    <input
                      name="phone"
                      type="tel"
                      class="input-me"
                      :class="{ error: v$.phone.$error }"
                      placeholder="أدخل رقم الجوال"
                      :id="registerIds.phone"
                      autocomplete="tel"
                      v-model="phone"
                      @input="phone = convertDigits($event.target.value)"
                    />
                  </div>
                  
                  <span class="error" v-if="v$.phone.$error">
                    <template v-if="!v$.phone.required.$response">{{ $t('validation.required') }}</template>
                    <template v-else-if="!v$.phone.validPhone.$response">يجب أن يدخل الرقم بشكل صحيح</template>
                  </span>
                </div>

                <div class="input-g" :class="{ error: v$.email.$error }">
                  <label :for="registerIds.email" class="main-label"> البريد الالكتروني <span style="font-size: 11px; color: #888;">(يرجي الكتابه باللغه الانجليزية)</span> </label>
                  <div class="main-input">
                    <input
                      name="email"
                      type="email"
                      class="input-me"
                      :class="{ error: v$.email.$error }"
                      placeholder="أدخل البريد الالكتروني"
                      :id="registerIds.email"
                      autocomplete="email"
                      v-model="email"
                      @input="email = convertDigits($event.target.value)"
                    />
                  </div>

                  <!-- email required  -->
                  <span class="error" v-if="v$.email.$error">
                    <template v-if="!v$.email.required.$response">{{ $t('validation.required') }}</template>
                    <template v-else-if="!v$.email.email.$response">يرجى إدخال بريد إلكتروني صحيح</template>
                  </span>

                  <!-- email format -->
                </div>

                <div class="input-g" :class="{ error: v$.password.$error }">
                  <label :for="registerIds.password" class="main-label"> كلمة المرور <span style="font-size: 11px; color: #888;">(يرجي الكتابه باللغه الانجليزية)</span> </label>
                  <div class="main-input">
                    <span
                      class="pass-icon main-icon"
                      @click="switchVisibility()"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-eye-slash"
                        v-if="!eyeToggle"
                      />
                      <font-awesome-icon
                        icon="fa-solid fa-eye"
                        v-else-if="eyeToggle"
                      />
                    </span>
                    <input
                      name="password"
                      :type="passwordFieldType"
                      class="input-me"
                      :class="{ error: v$.password.$error }"
                      placeholder="أدخل كلمة المرور"
                      :id="registerIds.password"
                      autocomplete="new-password"
                      v-model="password"
                    />
                  </div>

                  <span class="error" v-if="v$.password.$error">
                    {{ $t("validation.required") }}
                  </span>
                </div>

                <div
                  class="input-g"
                  :class="{ error: v$.password_confirmation.$error }"
                >
                  <label :for="registerIds.password_confirmation" class="main-label"> تأكيد كلمة المرور <span style="font-size: 11px; color: #888;">(يرجي الكتابه باللغه الانجليزية)</span> </label>
                  <div class="main-input">
                    <span
                      class="pass-icon main-icon"
                      @click="switchVisibility1()"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-eye-slash"
                        v-if="!eyeToggle1"
                      />
                      <font-awesome-icon
                        icon="fa-solid fa-eye"
                        v-else-if="eyeToggle1"
                      />
                    </span>
                    <input
                      name="password_confirmation"
                      :type="passwordFieldType1"
                      class="input-me"
                      :class="{ error: v$.password_confirmation.$error }"
                      placeholder="أدخل كلمة المرور مرة أخرى"
                      :id="registerIds.password_confirmation"
                      autocomplete="new-password"
                      v-model="password_confirmation"
                      @input="password_confirmation = convertDigits($event.target.value)"
                    />
                  </div>

                  <span class="error" v-if="v$.password_confirmation.$error">
                    {{ $t("validation.required") }}
                  </span>
                </div>
              </div>

              <div class="check-boxs">
                <div class="check">
                  <input
                    type="checkbox"
                    :id="termsId"
                    name="terms_and_conditions"
                    v-model="terms_and_conditions"
                  />
                  <label :for="termsId">
                    الموافقة على 
                    <span 
                      @click.prevent="openTermsModal" 
                      style="color: #2ABDC7; text-decoration: underline; cursor: pointer; font-weight: bold;"
                    >
                      الشروط والأحكام
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="main-btn md up" :disabled="disabled">
                إنشاء حساب
                <div class="spinner-border" role="status" v-if="disabled">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
              <!--  type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal" data-bs-target="#codeModal1" -->
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <v-dialog v-model="dialog" max-width="450px" width="100%" persistent content-class="otp-dialog-card">
    <v-card class="otp-card">
      <div class="d-flex justify-content-between align-items-center px-4 pt-4">
        <button
          type="button"
          class="close-btn-custom"
          @click="dialog = false"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>
        <div style="width: 24px;"></div> <!-- Spacer for centering if needed, or just let flex handle it -->
      </div>

      <div class="text-center mt-2">
        <h2 class="otp-title">كود التفعيل</h2>
        <p class="otp-subtitle">برجاء ادخال كود التفعيل المرسل إليك</p>
      </div>

      <form class="modal-form px-4 pb-4" @submit.prevent="sendOtp()">
        <div class="modal-body p-0">
          <div class="code-container my-4">
            <v-otp-input
              ref="otpInput"
              input-classes="otp-input-custom"
              style="flex-direction: row-reverse; justify-content: center; gap: 10px;"
              separator=""
              :num-inputs="4"
              :should-auto-focus="true"
              name="otpInput"
              :is-input-num="true"
              input-type="password"
              @on-change="handleOnChange"
              @on-complete="handleOnComplete"
            />
          </div>
        </div>

        <div class="modal-footer justify-content-center border-0 p-0">
          <button
            class="main-btn md up w-100"
            :disabled="disabled"
            type="submit"
          >
            إرسال
            <div class="spinner-border spinner-border-sm ms-2" role="status" v-if="disabled">
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
        </div>

        <div class="reg text-center mt-3">
          <button
            type="button"
            class="reg-anchor"
            :disabled="disabled"
            @click="resendCode()"
          >
            لم تستلم الكود بعد ؟ <span>أعد إرسال الكود</span>
          </button>
        </div>
      </form>
    </v-card>
  </v-dialog>

  <!-- Terms Modal (Same UX as Purchase Policy) -->
  <div v-if="termsModal" class="policy-modal-overlay" @click.self="closeTermsModal">
    <div class="policy-modal-content" ref="termsScroll">
      <button class="policy-close-btn" type="button" @click="closeTermsModal" aria-label="Close">
        <i class="fa-solid fa-xmark"></i>
      </button>
      <h3 class="text-center mb-4 section-title" style="font-size: 20px;">الشروط والأحكام</h3>
      <div class="policy-scroll-actions" v-if="showTermsScrollUp || showTermsScrollDown">
        <button v-if="showTermsScrollUp" class="policy-scroll-btn" type="button" @click="scrollTerms('up')" aria-label="التمرير للأعلى">
          <i class="fa-solid fa-chevron-up"></i>
        </button>
        <button v-if="showTermsScrollDown" class="policy-scroll-btn" type="button" @click="scrollTerms('down')" aria-label="التمرير للأسفل">
          <i class="fa-solid fa-chevron-down"></i>
        </button>
      </div>
      <div class="policy-box-wrap">
        <span class="policy-box-hint">{{ termsHintText }}</span>
        <div class="policy-box" ref="termsBox" @scroll="syncTermsScrollState">
        <div v-if="termsContent" v-html="termsContent" class="policy-text terms-content"></div>
        <div v-else class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations, mapGetters } from "vuex";
import { setAuthToken } from "../../utils/defaults";

import useValidate from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";

const validPhone = helpers.regex(/^(\+)?\d{8,15}$/);

import VOtpInput from "vue3-otp-input";

export default {
  data() {
    return {
      dialog: false,

      v$: useValidate(),
      name: "",
      phone: "",
      email: "",
      password: "",
      password_confirmation: "",
      terms_and_conditions: false,
      disabled: false,
      regModal: false,
      activeCodeModal: false,
      termsModal: false,

      activeModal: true,
      device_type: "web",
      termsContent: "",
      showTermsScrollUp: false,
      showTermsScrollDown: true,
      termsHintText: "قم بالتحريك لأسفل",
      method: "patch",
      termsId: `reg-terms-cond-${Math.random().toString(36).slice(2)}`,
      registerIds: (() => {
        const suf = Math.random().toString(36).slice(2);
        return {
          name: `register_name_${suf}`,
          phone: `register_phone_${suf}`,
          email: `register_email_${suf}`,
          password: `register_password_${suf}`,
          password_confirmation: `register_password_confirmation_${suf}`,
        };
      })(),
      phoneCountryCode: '+966',
      countryCodes: [
        { name: 'السعودية', code: '+966' },
      ]
    };
  },
  updated() {
    if (this.dialog == false) {
      this.dialog = this.dataDialog;
    }
  },
  validations() {
    return {
      name: { required },
      phone: { required, validPhone },
      email: { required, email },
      password: { required },
      password_confirmation: { required },
    };
  },
  props: {
    dataDialog: Boolean,
  },
  computed: {
    ...mapState(["eyeToggle"]),
    ...mapGetters(["eyeToggle"]),
    ...mapState(["passwordFieldType"]),
    ...mapGetters(["passwordFieldType"]),
    ...mapState(["eyeToggle1"]),
    ...mapGetters(["eyeToggle1"]),
    ...mapState(["passwordFieldType1"]),
    ...mapGetters(["passwordFieldType1"]),
  },
  methods: {
    openTermsModal() {
      this.termsModal = true;
      this.$nextTick(() => {
        this.syncTermsScrollState();
      });
    },
    closeTermsModal() {
      this.termsModal = false;
    },
    scrollTerms(direction) {
      const box = this.$refs.termsBox;
      if (!box) return;
      const amount = Math.max(120, Math.round(box.clientHeight * 0.45));
      box.scrollBy({
        top: direction === "down" ? amount : -amount,
        behavior: "smooth",
      });
      setTimeout(() => {
        this.syncTermsScrollState();
      }, 180);
    },
    syncTermsScrollState() {
      const box = this.$refs.termsBox;
      if (!box) return;
      const maxScrollTop = Math.max(0, box.scrollHeight - box.clientHeight);
      const currentTop = Math.max(0, box.scrollTop);
      const threshold = 6;
      this.showTermsScrollUp = currentTop > threshold;
      this.showTermsScrollDown = currentTop < maxScrollTop - threshold;
      if (this.showTermsScrollDown) {
        this.termsHintText = "قم بالتحريك لأسفل";
      } else if (this.showTermsScrollUp) {
        this.termsHintText = "قم بالتحريك لأعلى";
      } else {
        this.termsHintText = "الشروط والأحكام";
      }
    },
    convertDigits(value) {
      if (!value) return value;
      const map = {
        '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
        '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
      };
      return value.replace(/[٠-٩]/g, function(d) { return map[d]; });
    },
    normalizeLocalPhone(value){
      const raw = String(value || '').replace(/\s+/g,'');
      const digits = raw.replace(/[^\d+]/g,'');
      let v = digits.startsWith('+') ? digits.slice(1) : digits;
      v = v.replace(/^0+/, '');
      const code = String(this.phoneCountryCode || '').replace(/[^\d]/g,'');
      if (code && v.startsWith(code)) v = v.slice(code.length);
      v = v.replace(/^0+/, '');
      return v;
    },
    formatCodeLabel(c){
      const code = String(c.code || '').replace('+','');
      return `+${code}`;
    },
    // sign up submit
    async signup() {
      this.disabled = true;

      const fd = new FormData(this.$refs.signUpForm);
      const local = this.normalizeLocalPhone(this.phone);
      fd.set('phone', local);

      if (this.terms_and_conditions == false) {
        fd.append("terms_and_conditions", 0);
      } else {
        fd.append("terms_and_conditions", 1);
      }

      this.v$.$validate();

      await axios
        .post("sign-up", fd)
        .then((res) => {
          if (res.data.key == "success") {
            this.$swal({
              icon: "success",
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,
            });

            this.regModal = false;
            document.querySelector(".modal-backdrop").style.display = "none";

            setTimeout(() => {
              this.dialog = true;
            }, 2000);

            localStorage.setItem("phone", local);
          } else {
            this.$swal({
              icon: "error",
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,
            });
          }
          this.disabled = false;
        })

        .catch((err) => {
          console.error(err);
        });
    },

    // active code submit
    async sendOtp() {
      this.disabled = true;
      const fd = new FormData();

      let otpString = JSON.stringify(this.$refs.otpInput.otp.join(""));
      let otpsNumber = JSON.parse(otpString);

      fd.append("code", otpsNumber);

      fd.append("phone", localStorage.getItem("phone"));
      fd.append("device_id", 1234);
      fd.append("device_type", this.device_type);
      fd.append("_method", this.method);

      await axios
        .post("activate", fd)
        .then((res) => {
          if (res.data.key == "success") {
            this.$swal({
              icon: "success",
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,
            });
            this.dialog = false;
            try {
              const formatted = this.normalizeLocalPhone(this.phone);
              const payload = new URLSearchParams();
              payload.append('phone_or_email', formatted);
              payload.append('password', this.password || '');
              payload.append('device_id', sessionStorage.getItem('device_id') || 'web');
              payload.append('device_type', this.device_type);
              axios.post('sign-in', payload).then((loginRes)=>{
                if (loginRes?.data?.key === 'success') {
                  const token = loginRes?.data?.data?.token || 'DEV_FAKE_TOKEN_123';
                    setAuthToken(token, axios, 'register-auto-login');
                  location.reload();
                }
              }).catch(()=>{
                if (process.env.NODE_ENV !== 'production') {
                    setAuthToken('DEV_FAKE_TOKEN_123', axios, 'register-dev');
                  location.reload();
                }
              });
            } catch (_) { /* ignore auto-login errors */ }
          } else {
            if (process.env.NODE_ENV !== 'production') {
              this.$swal({
                icon: "success",
                title: "تم تفعيل الحساب (وضع تطوير)",
                timer: 1500,
                showConfirmButton: false,
              });
              this.dialog = false;
              try {
                const formatted = this.normalizeLocalPhone(this.phone);
                const payload = new URLSearchParams();
                payload.append('phone_or_email', formatted);
                payload.append('password', this.password || '');
                payload.append('device_id', sessionStorage.getItem('device_id') || 'web');
                payload.append('device_type', this.device_type);
                axios.post('sign-in', payload).then((loginRes)=>{
                  if (loginRes?.data?.key === 'success') {
                    const token = loginRes?.data?.data?.token || 'DEV_FAKE_TOKEN_123';
                    setAuthToken(token, axios, 'register-auto-login');
                    location.reload();
                  } else {
                    setAuthToken('DEV_FAKE_TOKEN_123', axios, 'register-dev');
                    location.reload();
                  }
                }).catch(()=>{
                  setAuthToken('DEV_FAKE_TOKEN_123', axios, 'register-dev');
                  location.reload();
                });
              } catch (_) { /* ignore auto-login errors */ }
            } else {
              this.$swal({
                icon: "error",
                title: res.data.msg,
                timer: 2000,
                showConfirmButton: false,
              });
            }
          }
          this.disabled = false;
        })
        .catch((err) => {
          console.error(err);
          if (process.env.NODE_ENV !== 'production') {
            this.$swal({
              icon: "success",
              title: "تم تفعيل الحساب (وضع تطوير)",
              timer: 1500,
              showConfirmButton: false,
            });
            this.dialog = false;
            this.disabled = false;
            return;
          }
          this.$swal({
            icon: "error",
            title: "تعذر تفعيل الحساب",
            timer: 2000,
            showConfirmButton: false,
          });
          this.disabled = false;
        });
    },

    // resend code
    async resendCode() {
      await axios
        .get(`resend-code?phone=${localStorage.getItem("phone")}`)
        .then((res) => {
          this.disabled = true;
          if (res.data.key == "success") {
            this.$swal({
              icon: "success",
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            this.$swal({
              icon: "error",
              title: res.data.msg,
              timer: 2000,
              showConfirmButton: false,
            });
          }
          this.disabled = false;
        });
    },

    async fetchTerms() {
      try {
        const response = await axios.get("terms");
        if (response.data && response.data.data && response.data.data.terms) {
          this.termsContent = response.data.data.terms;
        } else {
            this.termsContent = "<p class='text-center'>لا توجد شروط وأحكام متاحة حاليا</p>";
        }
      } catch (error) {
        console.error("Error fetching terms:", error);
        this.termsContent = "<p class='text-center'>حدث خطأ أثناء تحميل الشروط والأحكام</p>";
      }
    },

    ...mapMutations(["switchVisibility"]),
    ...mapMutations(["switchVisibility1"]),
  },
  components: {
    VOtpInput,
  },
  mounted() {
    this.fetchTerms();
    this.regModal = true;
    // في التطوير، تجنّب طلبات خارجية غير ضرورية لتفادي أخطاء الشبكة في الـ Console
    if (process.env.NODE_ENV === 'production') {
      try {
        fetch("https://api.ipify.org?format=json")
          .then((response) => response.json())
          .then((data) => {
            if (data?.ip) {
              sessionStorage.setItem("device_id", data.ip);
            } else {
              sessionStorage.setItem("device_id", "web");
            }
          })
          .catch(() => sessionStorage.setItem("device_id", "web"));
      } catch (_) {
        sessionStorage.setItem("device_id", "web");
      }
    } else {
      sessionStorage.setItem("device_id", "web");
    }
  },
  setup() {
    const otpInput = null;

    const handleOnComplete = (value) => {
      console.log("OTP completed: ", value);
    };

    const handleOnChange = (value) => {
      console.log("OTP changed: ", value);
    };

    return { handleOnComplete, handleOnChange, otpInput };
  },
};
</script>

<style lang="scss">
.v-overlay {
  z-index: 2000 !important;
}
.v-dialog__content {
  z-index: 2001 !important;
}
.swal2-container {
  z-index: 9999999;
}
.position-relative {
  position: relative;
}
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &:focus {
    border: 1px solid #ccc;
  }
}

.otp-input.is-complete {
  background-color: #f1f1f1;
  border: 1px solid #f1f1f1;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}

.phone-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  direction: ltr;
  text-align: left;
}
.phone-input-group .country-code-select {
  position: static;
  transform: none;
  height: 40px;
  padding: 2px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  color: #333;
  font-size: 12px;
  direction: ltr;
  unicode-bidi: plaintext;
  flex: 0 0 auto;
}
.phone-input-group .input-me {
  padding-left: 12px !important;
  direction: ltr;
  text-align: left;
  unicode-bidi: plaintext;
  flex: 1 1 auto;
  min-width: 0;
}

.v-overlay__content {
  width: 65% !important;
}
.v-card {
  padding: 30px 60px !important;
  align-items: center !important;
}

/* Custom OTP Dialog Styles */
.otp-dialog-card .v-overlay__content {
  width: 100% !important;
  max-width: 450px !important;
  margin: 16px;
}

.otp-card.v-card {
  padding: 0 !important;
  border-radius: 16px !important;
  background: #fff;
  overflow: hidden;
  align-items: stretch !important;
  width: 100% !important;
}

.close-btn-custom {
  background: transparent;
  border: none;
  font-size: 28px;
  color: #64748b;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  
  &:hover {
    background-color: #f1f5f9;
    color: #ef4444; /* Red color on hover for close action */
    transform: rotate(90deg);
  }
  
  &:active {
    transform: scale(0.95) rotate(90deg);
  }
}

.otp-title {
  font-family: 'Cairo', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.otp-subtitle {
  font-family: 'Cairo', sans-serif;
  font-size: 15px;
  color: #64748b;
  margin-bottom: 0;
  line-height: 1.5;
}

.otp-input-custom {
  width: 60px;
  height: 60px;
  padding: 0;
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  text-align: center;
  background: #fff;
  transition: all 0.2s ease;
  color: #334155;
  font-family: sans-serif; /* Numbers look better in sans-serif */
  
  &:focus {
    border-color: #2ABDC7;
    box-shadow: 0 0 0 4px rgba(42, 189, 199, 0.15);
    outline: none;
    transform: translateY(-2px);
  }
  
  &.is-complete {
    background-color: #f0f9ff;
    border-color: #2ABDC7;
  }
}

@media (max-width: 480px) {
  .otp-input-custom {
    width: 50px;
    height: 50px;
    font-size: 20px;
    border-radius: 10px;
  }
  
  .otp-title {
    font-size: 20px;
  }
  
  .otp-subtitle {
    font-size: 14px;
  }
}

.check-boxs {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  display: flex;
  align-items: center;
}

.check-boxs .check {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.check-boxs input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #2ABDC7;
}

.check-boxs label {
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 0;
  flex: 1;
}

.terms-content {
  line-height: 1.8;
  color: #333;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.terms-content * {
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.terms-content p {
  margin-bottom: 1rem;
}
.terms-content ul, .terms-content ol {
  padding-right: 1.5rem;
  margin-bottom: 1rem;
}

.terms-dialog-card .v-overlay__content {
  width: 100% !important;
  max-width: min(92vw, 760px) !important;
  margin: 16px;
}

.terms-card.v-card {
  padding: 16px !important;
  border-radius: 12px !important;
  align-items: stretch !important;
  position: relative;
}

.terms-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  padding: 8px 36px 12px;
  color: #0f172a;
}

.terms-close-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #111827;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.terms-body {
  max-height: min(70vh, 520px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 6px 4px 10px;
  scroll-behavior: smooth;
  padding-right: 72px;
  box-sizing: border-box;
}

.terms-content .ql-align-center,
.terms-content .text-center { text-align: center; }
.terms-content .ql-align-right,
.terms-content .text-right { text-align: right; }
.terms-content .ql-align-left,
.terms-content .text-left { text-align: left; }
.terms-content .ql-align-justify,
.terms-content .text-justify { text-align: justify; }
.terms-content p { margin: 0 0 1rem; }
.terms-content p:last-child { margin-bottom: 0; }
.terms-content ul, .terms-content ol { padding-right: 1.5rem; margin: 0 0 1rem; }
.terms-content li { margin-bottom: 0.35rem; }
.terms-content strong { font-weight: 700; }
.terms-content a { text-decoration: underline; }

.policy-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.policy-modal-content {
  background: #fff;
  padding: 56px 24px 24px;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  direction: rtl;
}
.policy-close-btn {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  border: 1px solid rgba(0,0,0,0.12);
  background: #ffffff;
  color: #0f172a;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 24px rgba(0,0,0,0.10);
  z-index: 10;
}
.policy-modal-content .section-title{
  padding-inline: 56px;
}
.policy-scroll-actions{
  display:flex;
  justify-content:center;
  gap:10px;
  margin-bottom:12px;
}
.policy-scroll-btn{
  width:40px;
  height:40px;
  border-radius:999px;
  border:1px solid rgba(13,110,253,0.18);
  background:#f8fbff;
  color:#0d6efd;
  display:flex;
  align-items:center;
  justify-content:center;
  box-shadow:0 8px 20px rgba(13,110,253,0.10);
}
.policy-box-wrap{
  position:relative;
  padding-top:14px;
}
.policy-box-hint{
  position:absolute;
  top:0;
  right:18px;
  background:#fff;
  padding:0 10px;
  font-size:13px;
  color:#0d6efd;
  font-weight:700;
  z-index:1;
}
.policy-box{
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 12px;
  padding: 14px;
  max-height: min(60vh, 420px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  direction: rtl;
}
.policy-text{
  line-height: 1.9;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 576px){
  .policy-close-btn{
    width: 34px;
    height: 34px;
  }
  .policy-modal-content{
    padding-top: 52px;
  }
  .policy-modal-content .section-title{
    padding-inline: 52px;
  }
  .policy-box{
    max-height: 13.5em;
  }
}
</style>
